var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { Row, Col, Modal } from "react-bootstrap";
import ErrorText from "@irati/ui/src/ErrorText";
import Input from "@irati/ui/src/FormItem/Input";
import Form from "@irati/ui/src/Form";
import Button from "@irati/ui/src/Button";
import { Firstname, Lastname, Email, ExternalID } from "@irati-web/fields/user";
import Picture from "@irati/ui/src/ProfilePicture";
import { Para } from "@irati/ui/src/Labels";
import { getTeamSchema } from "@irati/admin/helpers/validation/schema";
import { FIRSTNAME, LASTNAME, EMAIL, TEAMS, EXTERNAL_ID } from "@irati/admin/helpers/userCSV";
import PictureWrapper from "./styled/Picture";
import Info from "./styled/Info";
import FailedUser from "./styled/FailedUser";
import Flex from "./styled/Flex";
import MarginRightButton from "./styled/MarginRightButton";
import Trashcan from "./styled/Trashcan";
var EditFailedUser = /** @class */ (function (_super) {
    __extends(EditFailedUser, _super);
    function EditFailedUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            showErrors: true
        };
        _this.openModal = function () {
            _this.setState({ open: true });
        };
        _this.hideModal = function () {
            _this.setState({ open: false });
        };
        _this.remove = function () {
            _this.hideModal();
            _this.props.removeUser(_this.props.user);
        };
        _this.handleChange = function (label, value) {
            _this.props.user[label] = value;
            _this.setState({ showErrors: false });
        };
        _this.hasHeader = function (header) {
            return _this.props.headers.find(function (test) { return test === header; });
        };
        return _this;
    }
    EditFailedUser.prototype.render = function () {
        var _this = this;
        var _a = this.state, showErrors = _a.showErrors, open = _a.open;
        var _b = this.props, user = _b.user, formatMessage = _b.formatMessage;
        var email = user.email, firstName = user.firstName, lastName = user.lastName, teams = user.teams, external_id = user.external_id;
        return (React.createElement(FailedUser, null,
            !!(this.hasHeader(FIRSTNAME) || this.hasHeader(LASTNAME)) && (React.createElement(PictureWrapper, null,
                React.createElement(Picture, { user: user, regular: true }))),
            React.createElement(Info, null,
                React.createElement(Flex, null,
                    React.createElement(Form, null,
                        React.createElement(Row, null,
                            this.hasHeader(FIRSTNAME) && (React.createElement(Col, { xs: 12, sm: 6, md: 3 },
                                React.createElement(Firstname, { value: firstName, onChange: function (value) { return _this.handleChange("firstName", value); } }))),
                            this.hasHeader(LASTNAME) && (React.createElement(Col, { xs: 12, sm: 6, md: 3 },
                                React.createElement(Lastname, { value: lastName, onChange: function (value) { return _this.handleChange("lastName", value); } }))),
                            this.hasHeader(EMAIL) && (React.createElement(Col, { xs: 12, sm: 6, md: 3 },
                                React.createElement(Email, { value: email, onChange: function (value) { return _this.handleChange("email", value); } }))),
                            this.hasHeader(TEAMS) && (React.createElement(Col, { xs: 12, sm: 6, md: 3 },
                                React.createElement(Input, { label: formatMessage({ id: "admin.components.editFailedUser.fields.label.team" }), type: "text", name: "team", value: teams, onChange: function (value) { return _this.handleChange("teams", value); }, validation: getTeamSchema() }))),
                            this.hasHeader(EXTERNAL_ID) && (React.createElement(Col, { xs: 12, sm: 6, md: 3 },
                                React.createElement(ExternalID, { value: external_id, onChange: function (value) { return _this.handleChange("external_id", value); } }))),
                            React.createElement(Trashcan, { onClick: this.openModal })),
                        showErrors &&
                            user.error.map(function (error, i) { return (React.createElement(Row, { key: i },
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(ErrorText, null,
                                        React.createElement(FormattedMessage, { id: error }))))); })),
                    React.createElement(Modal, { className: "remove-user", show: open, onHide: function () { return _this.setState({ open: false }); } },
                        React.createElement(Modal.Body, null,
                            React.createElement(Para, { flush: true },
                                React.createElement(FormattedMessage, { id: "admin.components.editFailedUser.modal.body.text", values: { firstname: user.firstName || user.email } }))),
                        React.createElement(Modal.Footer, null,
                            React.createElement(MarginRightButton, { primary: true, onClick: this.remove },
                                React.createElement(FormattedMessage, { id: "admin.components.editFailedUser.button.yes" })),
                            React.createElement(Button, { onClick: this.hideModal },
                                React.createElement(FormattedMessage, { id: "admin.components.editFailedUser.button.no" }))))))));
    };
    return EditFailedUser;
}(Component));
export default injectIntl(EditFailedUser);
